import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { TimelineMax, TweenLite, Power3 } from "gsap";
import { IDimConfig, ResizeHelper, LayoutDimData } from"@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { Point, Text } from "pixi.js";
import { StateHandler } from "@nolimitcity/slot-game/bin/core/utils/StateHandler";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { SanGameConfig} from "../../../SanGameConfig"

import { TextStyleConfig } from "../../../translation/TextStyleConfig"
import { GameResources } from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import { Sequence } from "@nolimitcity/slot-game/bin/core/displayobject/Sequence";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { TranslationConfig } from "../../../translation/TranslationConfig";
import { MathHelper } from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {SanQuentin} from "../../../SanQuentin";

export class XWayStateLevel extends StateHandler{

    public static LEVEL_1:number = 0;
    public static LEVEL_2:number = 1;
    public static LEVEL_3:number = 2;

    protected static ValueLvls:number[] = [800,2200,4600];
    protected static TextureLvls:string[] = ["Header_A","Header_B","Header_C"];
    protected static SpineLvls:string[] = ["Header_Loop_A","Header_Loop_B","Header_Loop_C"];

    public get lastLvl():number{
        return XWayStateLevel.ValueLvls[this.state-1] ? XWayStateLevel.ValueLvls[this.state-1] : 0;
    }

    public get nextLvl():number{
        return XWayStateLevel.ValueLvls[this.state+1] ? XWayStateLevel.ValueLvls[this.state+1] : 100000000000000;
    }

    public get valueLvl():number{
        return XWayStateLevel.ValueLvls[this.state]
    }

    public get TextureLvl():string{
        return XWayStateLevel.TextureLvls[this.state]
    }

    public get SpineLvl():string{
        return XWayStateLevel.SpineLvls[this.state]
    }

    public set(value:number):boolean{
        if(value > XWayStateLevel.LEVEL_3 || value < XWayStateLevel.LEVEL_1) return false;
        super.set(value);
        return true;
    }
}

export class XWaysCounter extends BaseView {


    protected _maxWinPost:Text;
    protected _maxWinAmount:Text;
    

    protected value:number = 243;

    protected _textCounter:Text;
    protected _textPost:Text;
    private xway_logo:Sequence;

    protected _timeLine:TimelineMax;
    protected _xwayState:XWayStateLevel = new XWayStateLevel(XWayStateLevel.LEVEL_1);
    //Header
    protected _countsUp:boolean = true;

    protected CounterDim:IDimConfig = {
        dimOrientation : {
            landscape :{
                scale:      new Point( 1, 1),
                position:   new Point( -72, 380),
                // position:   new Point( 800, 2),
                layout :{
                    left:   new Point( -72, 380),
                    right:  new Point( -72, 380)
                }
            },
            portrait :{
                scale:      new Point( 1, 1),
                position:   new Point( 410, -180)
            }
        },
        WIDTH: 900,
        HEIGHT: 540,
    };

    // text style for 39647 Ways

    private static _instance:XWaysCounter;
    public static get instance():XWaysCounter{
        return this._instance;
    }

    constructor() {
        super();
        XWaysCounter._instance = this;
        StageManager.getLayer(SanGameConfig.instance.LAYERS.FEATURE.name).addChild(this);
    }

    public get dim():LayoutDimData{ return ResizeHelper.calcDim(this.CounterDim); };

    protected initAnimations():void{

        this.xway_logo = this.addChild(Sequence.createSequence());
        this.xway_logo.alpha = 1;
        
        this._textCounter = this.createTextObject();
        this._textPost = this.createTextObject();
        this._textPost.position.y += this._textCounter.height/1.5;
        this._textPost.text = Translation.translate(TranslationConfig.SIDE_COUNTER_WAYS);
        this._textPost.updateTransform();


        this._maxWinPost = this.createTextObject();
        this._maxWinPost.style = TextStyleConfig.MAX_WIN_TEXT;
        this._maxWinPost.text = Translation.translate(TranslationConfig.WIN_UP_TO);
        this._maxWinPost.updateTransform();

        this._maxWinAmount = this.createTextObject();
        this._maxWinAmount.style = TextStyleConfig.MAX_WIN_TEXT;
        this._maxWinAmount.text = "150 000 X";

        if(!SanQuentin.api.gameClientConfiguration.showLowProbabilityGfx){
            this._maxWinAmount.visible=false;
            this._maxWinPost.visible=false;
        }
        const sizingIt:number = this._maxWinPost.width > 250 ? 250/this._maxWinPost.width : 1;
        this._maxWinPost.scale = MathHelper.pointMul(<PIXI.Point>this._maxWinPost.scale,sizingIt);

        this._maxWinAmount.updateTransform();
            
        this.updateValue();
        this.onResize();
    }

    protected createTextObject():Text{
        const textObj = new Text(this.value.toString());
        textObj.style = TextStyleConfig.TOTAL_XWAYS;
        textObj.anchor.set(0.5,0.5);
        this.addChild(textObj);
        return textObj;
    }

    public hardSetValue(value:number):void{
        this.value = value;
        this.updateValue();
    }

    public setValue(from:number | undefined, to:number, duration:number):TimelineMax {
        this._timeLine = Helper.timeLineKiller(this._timeLine, new TimelineMax());
        if(!this._textCounter.visible) return this._timeLine;
        if(this.value == to) return new TimelineMax();
        let fromValue = from != undefined ? from : this.value;

        this._countsUp = to > fromValue;
        
        this._timeLine = new TimelineMax({ onUpdate:() => { this.updateValue(); }, onComplete:() => this.updateValue()} );
        this._timeLine.fromTo(this,duration,{value:fromValue},{value:to});
        return this._timeLine;
    }

    public counterActive(value:boolean):void{
        this._textCounter.visible = value;
    }

    private _isFS:boolean = false;

    public changeModePos(mode:boolean):TweenLite[]{
        this._isFS = mode;
        const arra:TweenLite[] = [];

        if(this._isFS && ResizeHelper.IsLandscape()){
            arra.push(TweenLite.fromTo(this,0.15,{alpha:1},{alpha:0.5,delay:0.5}));
            arra.push(TweenLite.to(this.position,3,{y:"-=125",delay:0.5}));
            arra.push(TweenLite.to(this,1,{alpha:1,delay:2.5}));
        }else if(!this._isFS){
            arra.push(TweenLite.fromTo(this,0.15,{alpha:1},{alpha:0.5}));
            arra.push(TweenLite.to(this.position,1.25,{y:this.dim.position.y}));
            arra.push(TweenLite.to(this, 0.75,{alpha:1, delay:0.5}));
        }
        return arra;
    }
    

    public onResize():void{
        this.visible = !ResizeHelper.isIPadd();
        this.position = this.dim.position;
        const modeYOfsset:number = this._isFS && ResizeHelper.IsLandscape() ? -125 : 0;
        this.position.y += modeYOfsset;

        this.scale = this.dim.scale;

        const pathTexture:string = "Xways_Sign/" + (ResizeHelper.IsLandscape() ? "Xways_Left" : "Xways_top");
        this.xway_logo.setTexture(GameResources.getTextures(pathTexture));

        // this._textCounter.position.y = modeYOfsset;
        // this._textPost.position.y = this._textCounter.position.y + this._textCounter.height/1.5;

        this.xway_logo.pivot.x = ResizeHelper.IsLandscape() ? 0 : 50;
        this.xway_logo.pivot.y =  (ResizeHelper.IsLandscape() ? 30 : -15);

        this._maxWinPost.position.y = (ResizeHelper.IsLandscape() ? -190 : 90);
        this._maxWinAmount.position.y = (ResizeHelper.IsLandscape() ? this._maxWinPost.position.y+30 : 90);

        const totWidht:number =  this._maxWinPost.width*this._maxWinPost.scale.x + this._maxWinAmount.width;

        this._maxWinPost.position.x = ResizeHelper.IsLandscape() ? 0 : -(totWidht*0.5);
        this._maxWinAmount.position.x = ResizeHelper.IsLandscape() ? 0 : (this._maxWinPost.position.x + this._maxWinPost.width*this._maxWinPost.scale.x) + this._maxWinPost.width/4;

        this.visible  = !ResizeHelper.isIPadd();
    }

    protected updateValue():void{
        this._textCounter.text = this.value.toFixed(0);

        if(!this._textCounter.visible) return;

        if(this._countsUp){
            if(this.value > this._xwayState.valueLvl && this._xwayState.set(this._xwayState.state+1)){
                TweenLite.to(this._textCounter.scale,0.15,{x:1.2,y:1.2}).eventCallback("onComplete",() => TweenLite.to(this._textCounter.scale,0.15,{x:1,y:1}))
            }
        }else{
            if(this.value < this._xwayState.lastLvl && this._xwayState.set(this._xwayState.state-1)){
                TweenLite.to(this._textCounter.scale,0.1,{x:0.95,y:0.95}).eventCallback("onComplete",() => TweenLite.to(this._textCounter.scale,0.1,{x:1,y:1}))
            }
        }

        this._textCounter.text;
        this._textCounter.updateTransform();
    }
}